import api from "@api"
import { useStore } from "@stores"
import { useAppContext } from "@components/AppContext"

export const indexOperation = api.get("notifications/ListTemplates")
export const resetOperation = api.get("notifications/ResetTemplate")
export const toggleOperation = api.get("notifications/ToggleTemplate")
export const updateOperation = api.get("notifications/UpdateTemplate")

export const CATEGORIES = {
  DWOLLA: 'DWOLLA',
  FUNDING: 'FUNDING',
  BACKSTAGE: 'BACKSTAGE',
  INVESTMENT: 'INVESTMENT',
  PROJECT_DROPOUTS: 'PROJECT_DROPOUTS',
  PROJECT_DOCUMENTS: 'PROJECT_DOCUMENTS',
}


const useTemplatesStore = (projectId) => {
  const { request, identity } = useAppContext()
  const { id: organizationId } = identity.organization

  const parameters = {}
  const dependencies = [ organizationId ]

  if (projectId) {
    parameters.projectId = projectId
    dependencies.push(projectId)
  }

  const {
    setItems,
    items: templates = [],
  } = useStore(indexOperation.id, request, true, parameters, dependencies)

  const getTemplates = category =>
    templates
      .filter(template => template.category === category)

  const getTemplateByKey = key =>
    (templates || []).find(item => item.key === key)

  const updatedTemplateByKey = (updatedTemplate) => {
    setItems((prevItems = []) =>
      prevItems.map(template => ({
        ...(template.key === updatedTemplate.key ? updatedTemplate : template)
      }))
    )
  }

  const resetTemplate = id =>
    request(resetOperation.id, { id })
      .then(({ data }) => updatedTemplateByKey(data))

  const toggleTemplate = (id, isEnabled) =>
    request(toggleOperation.id, { id, ...parameters, mutation: { isEnabled } })
      .then(({ data }) => updatedTemplateByKey(data))

  return {
    getTemplates,
    resetTemplate,
    toggleTemplate,
    getTemplateByKey,
    updatedTemplateByKey,
  }
}

export default useTemplatesStore
